import React, { use } from 'react'
import {useState} from 'react'

export default function Calculator() {

    const [result, setResult] = useState<string>('')
    const [results, setResults] = useState<string[]>([])
    const handleAddToResult = (event: any) => {
        
        if (result == 'Результат добавлен') {
            alert('Подождите!')
        } else {
            let clickedItem: any = event.target
            setResult(result + clickedItem.textContent)

        } 
    } 

    const handleDeleteResults = () => {
        setResults([])
    }

    const handleSolve = () => {
        let expression = result
        let countOps: number = expression.split('+').length - 1 + expression.split('×').length - 1 + expression.split('÷').length - 1 + expression.split('-').length - 1 

        
        if (countOps > 1 && expression[0] !== '-') {
            alert('Разрешена одна операция!')
            setResult('')
        } else if (expression[0] === '+' || expression[0] === '×' || expression[0] === '÷') {
            alert('Неверная операция!')
            setResult('')
        } else if (expression[0] === '-') {
            expression = expression.slice(1)
            if (expression.includes('+')) {
                let arr: string[] = expression.split('+')
                let leftNumber: number = -Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber + rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('-')) {
                let arr: string[] = expression.split('-')
                let leftNumber: number = -Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber - rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('÷')) {
                let arr: string[] = expression.split('÷')
                let leftNumber: number = -Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber / rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('×')) {
                let arr: string[] = expression.split('×')
                let leftNumber: number = -Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber * rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            // console.log(results)
        } else {
            if (expression.includes('+')) {
                let arr: string[] = expression.split('+')
                let leftNumber: number = Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber + rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('-')) {
                let arr: string[] = expression.split('-')
                let leftNumber: number = Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber - rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('÷')) {
                let arr: string[] = expression.split('÷')
                let leftNumber: number = Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber / rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен')
                setResults([...results, example])
            }

            if (expression.includes('×')) {
                let arr: string[] = expression.split('×')
                let leftNumber: number = Number(arr[0])
                let rightNumber: number = Number(arr[1])
                let example: string 
                example = String(leftNumber * rightNumber)
                setTimeout(() => {
                    setResult('')
                }, 1.5*1000)
                setResult('Результат добавлен (внизу)')
                setResults([...results, example])
            }
        }


    }

    const handleClearPanel = () => {
        setResult('')
    }

    const handleDeleteResult = (id: number) => {
        setResults(prev => prev.filter((__, i) => i !== id))
    }

    return (
        <div className='container-calculator'>
            <p style={{
                marginBottom: 50,
                fontSize: 50,
                textAlign: 'center'
            }}>КАЛЬКУЛЯТОР</p>
            <div>
                <div className="calculator">
                    <div className="calculator-result">
                        {result}
                    </div>
                    <div className="calculator-panel">
                        <ul>
                            <li onClick={handleAddToResult} id='0'>0</li>
                            <li onClick={handleAddToResult} id='1'>1</li>
                            <li onClick={handleAddToResult} id='2'>2</li>
                            <li onClick={handleAddToResult} id='3'>3</li>
                            <li onClick={handleAddToResult} id='4'>4</li>
                            <li onClick={handleAddToResult} id='5'>5</li>
                            <li onClick={handleAddToResult} id='6'>6</li>
                            <li onClick={handleAddToResult} id='7'>7</li>
                            <li onClick={handleAddToResult} id='8'>8</li>
                            <li onClick={handleAddToResult} id='9'>9</li>
                            <li onClick={handleAddToResult} id='+'>+</li>
                            <li onClick={handleAddToResult} id='-'>-</li>
                            <li onClick={handleAddToResult} id='×'>×</li>
                            <li onClick={handleAddToResult} id='÷'>÷</li>
                            <li onClick={handleSolve} id='='>=</li>
                            <li onClick={handleClearPanel} id='delete'>стереть</li>
                        </ul>
                    </div>
                </div>
                <button className='delete-results' onClick={handleDeleteResults}> Удалить все результаты</button>
                <ul className='results'>
                    Результаты:
                    {results.map((item, index) => (
                        <div className='results-item'>
                            <li key={index}>Результат №{index+1}: {item}</li>
                            <button className='delete-result' onClick={() => handleDeleteResult(index)}>Удалить</button>
                        </div>
                    ))}
                </ul>
            </div>
        </div>
    )
}
